type WithoutNulls<T> = { [P in keyof T]: Exclude<T[P], null> };

export const replaceNullsWith = (replacement: unknown) => <T>(obj: T): WithoutNulls<T> =>
  Object.entries(obj).reduce(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    (acc, [key, value]) => ({ ...acc, [key]: value !== null ? value : replacement }),
    {} as WithoutNulls<T>
  );
